"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EndgamePage = /*#__PURE__*/function (_react$default$Compon) {
  function EndgamePage() {
    var _this;
    _classCallCheck(this, EndgamePage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EndgamePage, [].concat(args));
    _defineProperty(_this, "state", {});
    _defineProperty(_this, "stringInput", function (fieldName, label) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "text";
      var showErrors = _this.state.showErrors;
      var _ref = _this.state[fieldName] || {
          pristine: true
        },
        value = _ref.value,
        pristine = _ref.pristine;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group field field-string".concat((showErrors || !pristine) && !value ? " error" : "")
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: fieldName
      }, label), /*#__PURE__*/_react.default.createElement("input", {
        className: "form-control",
        name: fieldName,
        type: type,
        value: value || '',
        onChange: function onChange(e) {
          return _this.setState(_defineProperty2({}, fieldName, {
            value: e.target.value,
            pristine: false
          }));
        }
      }));
    });
    return _this;
  }
  _inherits(EndgamePage, _react$default$Compon);
  return _createClass(EndgamePage, [{
    key: "submit",
    value: function submit() {
      var _this$props = this.props,
        score = _this$props.score,
        gameTime = _this$props.gameTime,
        onSubmit = _this$props.onSubmit;
      var _this$state = this.state,
        firstName = _this$state.firstName,
        lastName = _this$state.lastName,
        email = _this$state.email;
      var undefinedOrEmpty = function undefinedOrEmpty(field) {
        if (!field) return true;
        if (!field.value) return true;
        return field.value.length === 0;
      };
      if (undefinedOrEmpty(firstName) || undefinedOrEmpty(lastName) || undefinedOrEmpty(email)) {
        this.setState({
          showErrors: true
        });
      } else {
        onSubmit({
          firstName: firstName.value,
          lastName: lastName.value,
          email: email.value,
          score: score,
          gameTime: gameTime
        });
      }
      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var score = this.props.score;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "endgame-page"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "F\xE9licitation, tu\xA0es\xA0ultra-rapide"), /*#__PURE__*/_react.default.createElement("div", {
        className: "scorebox"
      }, /*#__PURE__*/_react.default.createElement("label", null, "Votre score :"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("strong", null, score))), /*#__PURE__*/_react.default.createElement("p", {
        className: "form-label"
      }, "Remplissez ce formulaire pour terminer votre participation"), /*#__PURE__*/_react.default.createElement("div", {
        className: "score-form"
      }, this.stringInput('firstName', 'Prénom*'), this.stringInput('lastName', 'Nom*'), this.stringInput('email', 'Email*', 'email'), /*#__PURE__*/_react.default.createElement("div", {
        className: 'tsku-form-bottom'
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: 'btn btn-info',
        onClick: function onClick() {
          return _this2.submit();
        }
      }, "Envoyer"))));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = EndgamePage;